<template>
  <div class="ds-payment-guide-download">
    <img :src="downloadIllustration" class="ds-payment-guide-download__illustration" aria-hidden="true">

    <DsText as="bebas4" color="var(--ds-purple-900)" class="ds-payment-guide-download__title">
      Descarga tu gu&iacute;a<br class="ds-payment-guide-download__title-break">
      completa de pagos
    </DsText>

    <DsText as="body4" class="ds-payment-guide-download__copy">
      Descarga una gu&iacute;a visual con informaci&oacute;n importante sobre tu proceso y beneficios.
    </DsText>

    <DsButton
      label="Descargar gu&iacute;a"
      variant="contained"
      size="large"
      class="ds-payment-guide-download__button"
    />
  </div>
</template>

<script setup lang="ts">
import DsButton from '../atoms/DsButton.vue'
import DsText from '../atoms/DsText.vue'

const downloadIllustration = new URL('../../../../../assets/adjudicacion/download.svg', import.meta.url).href
</script>

<style scoped>
.ds-payment-guide-download {
  width: 100%;
  max-width: 962px;
  margin: 0 auto;
  background: var(--ds-grey-50);
  border-radius: 32px;
  padding: 48px 0;
  box-sizing: border-box;
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 28px;
  text-align: center;
}

.ds-payment-guide-download__illustration {
  display: block;
  width: 40px;
  height: 40px;
  object-fit: contain;
}

.ds-payment-guide-download__title {
  max-width: none;
  margin: 0 auto;
  font-size: 30px;
  text-align: center;
  display: block;
}

.ds-payment-guide-download__title-break {
  display: none;
}

.ds-payment-guide-download__copy {
  color: var(--ds-text-primary);
  font-size: var(--ds-body3-size);
  max-width: 48ch;
}

.ds-payment-guide-download__button {
  width: 370px;
  max-width: 100%;
}

@media (max-width: 767px) {
  .ds-payment-guide-download {
    gap: 22px;
    padding: 40px 48px;
  }

  .ds-payment-guide-download__illustration {
    width: 40px;
    height: 40px;
  }

  .ds-payment-guide-download__title {
    max-width: 16ch;
    font-size: var(--ds-bebas4-size);
  }

  .ds-payment-guide-download__title-break {
    display: block;
  }

  .ds-payment-guide-download__copy {
    max-width: 24ch;
  }

  .ds-payment-guide-download__button {
    width: 100%;
  }
}

@media (max-width: 1024px) {
  .ds-payment-guide-download {
    gap: 24px;
    border-radius: 24px;
    padding: 32px 24px;
  }

  .ds-payment-guide-download__illustration {
    width: 40px;
    height: 40px;
  }

}
</style>

